import { Flex, Table } from 'antd'
import Text from 'antd/es/typography/Text'
import Title from 'antd/lib/typography/Title'
import { FC } from 'react'
import PageLayout from '../../components/page-layout/page-layout'
import TableWrapper from '../../components/table-wrapper/table-wrapper'
import renderDatetime from '../../helpers/tables/render-datetime'
import { useGetRewindJobsQuery } from '../../store/api/rewind-jobs-api'
import { EndpointQueryParameters } from '../../types/strapi/strapi'
import { materialRequirementsPopulate } from '../schedules/flexo/constants/shipment-populate'
import { columns } from './columns'

const queryParams: EndpointQueryParameters = {
    populate: {
        approved_by: true,
        shipment: {
            populate: {
                stamp: { populate: ['tube', 'roller'] },
                virtualStamp: { populate: { roller: true } },
                machine: true,
                additional_machines: true,
                client: true,
                shipment_positions: true,
                materialRequirements: { populate: materialRequirementsPopulate },
                calculated: true,
                calculatedOnActual: true,
            },
        },
        rewind_job_executors: {
            populate: {
                user: true,
                machine: true,
            },
        },
        rewind_queue_entries: {
            populate: {
                machine: true,
            },
        },
    },
    sort: ['id:desc'],
}

const RewindHistoryPage: FC = () => {
    const { data } = useGetRewindJobsQuery(queryParams)
    const dataSource = data?.data || []

    return (
        <PageLayout title='История перемотки'>
            <TableWrapper style={{ flex: 'auto' }}>
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey='id'
                    size='small'
                    expandable={{
                        expandedRowRender(rewindJob) {
                            return (
                                <Flex gap={20}>
                                    <div>
                                        <Text strong>Фиксация работ</Text>
                                        {(rewindJob.rewind_job_executors || []).length === 0 ? (
                                            <div>Нет работ</div>
                                        ) : (
                                            <Table
                                                columns={[
                                                    {
                                                        dataIndex: ['user', 'username'],
                                                        title: 'Перемотчик',
                                                        width: 120,
                                                    },
                                                    {
                                                        dataIndex: ['machine', 'name'],
                                                        title: 'Станок',
                                                        width: 80,
                                                    },
                                                    {
                                                        dataIndex: ['start'],
                                                        title: 'Начало',
                                                        width: 120,
                                                        render: renderDatetime,
                                                    },
                                                    {
                                                        dataIndex: ['end'],
                                                        title: 'Окончание',
                                                        width: 120,
                                                        render: v => v && renderDatetime(v),
                                                    },
                                                    {
                                                        dataIndex: ['reason'],
                                                        width: 120,
                                                        title: 'Причина',
                                                    },
                                                ]}
                                                dataSource={rewindJob.rewind_job_executors}
                                                rowKey='documentId'
                                                pagination={false}
                                            />
                                        )}
                                    </div>
                                    <div>
                                        <Text strong>Очереди</Text>
                                        {(rewindJob.rewind_queue_entries || []).length === 0 ? (
                                            <div>Нет очередей</div>
                                        ) : (
                                            <Table
                                                columns={[
                                                    {
                                                        dataIndex: ['machine', 'name'],
                                                        title: 'Станок',
                                                        width: 100,
                                                    },
                                                    {
                                                        dataIndex: ['zone'],
                                                        title: 'Зона',
                                                        width: 100,
                                                    },
                                                ]}
                                                dataSource={rewindJob.rewind_queue_entries}
                                                rowKey='documentId'
                                                pagination={false}
                                            />
                                        )}
                                    </div>
                                </Flex>
                            )
                        },
                    }}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default RewindHistoryPage
